<template>
  <main class="content overview">
      <section v-if="this.$store.state.was_Upload_successful" class="status-bar is-flex">

      </section>

      <section class="heading has-padding">
        <h1 v-if="this.$store.state.was_Upload_successful">Protokoll wurde erfolgreich gesendet.</h1>
        <h1 v-else>Protokoll Upload fehlgeschlagen.</h1>
      </section>

      <section class="form has-padding">
          <h2 v-if="this.$store.state.was_Upload_successful" class="subline adj alt">Das Untersuchungsprotokoll wurde erfolgreich übermittelt. Die angelegten Protokolle können in der Übersicht kontrolliert werden.</h2>
          <h2 v-else class="subline adj alt">Das Untersuchungsprotokoll wurde leider nicht erfolgreich übermittelt. Bitte versuchen Sie die Inspektionsanlage erneut.</h2>
      </section>

    <div @click="goToPath('inspektionen')" class="button is-primary is-flex">
        <h3>Zur Übersicht</h3>
    </div>
  </main>
</template>

<script>
export default {
  name: 'status',
  data () {
      return ({
          data: ''
      })
  },
  methods: {
    goToPath (route) {
        this.$router.push(route);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.status-bar {
    width: 100%;
    height: 3rem;
    padding: 1rem;
    background-color: rgb(20, 200, 95);

    &::before {
        width: 20px;
        height: 15px;
        position: absolute;
        display: block;
        content: '';
        background-image: url('../assets/check_white.svg');
        background-repeat: no-repeat;
        background-size: contain;
    }
}

@media (min-width: 780px) {
  .has-padding {
    max-width: var(--maxWidth);
    margin: 0 auto;
  }
}
</style>